import { render, staticRenderFns } from "./AdvertisingProgramTerm.vue?vue&type=template&id=51541400&"
import script from "./AdvertisingProgramTerm.vue?vue&type=script&lang=ts&"
export * from "./AdvertisingProgramTerm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports